import { createReactComponent } from '@tabler/icons-react';

export const IconCustomArrowsExpandVertical = createReactComponent(
  'outline',
  'customArrowsExpandVertical',
  'CustomArrowsExpandVertical',
  [
    [
      'path',
      {
        key: 'customArrowsExpandVertical-path',
        d: 'M8.9,9l3.1-3.1,3.1,3.1M15.1,15.1l-3.1,3.1-3.1-3.1',
      },
    ],
  ]
);
